module.exports = __webpack_public_path__ + "img/aac.35e90d3a.png";